module.exports = __webpack_public_path__ + "media/assets/images/flags/is-6fe75b31c534cb50588f68741a5cd6ad.svg";